const INITIAL_STATE = {
    stations: [],
    planned_stations: [],
    loading: false,
    loading_station: false,
    position: null,
    station: null,
    filter: {}
};

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'GET_STATIONS':
            return { ...state, loading: true };
        case 'GET_STATIONS_SUCCESS':
            return { ...state, loading: false, stations: action.stations }

        case 'GET_PLANNED_STATIONS':
            return { ...state };
        case 'GET_PLANNED_STATIONS_SUCCESS':
            return { ...state, planned_stations: action.stations }

        case 'SET_GEO_POSITION':
            return { ...state, position: action.payload.position }

        case 'GET_STATION':
            return { ...state, loading_station: true };
        case 'GET_STATION_SUCCESS':
            return { ...state, loading_station: false, station: action.station }
        case 'RESET_STATION':
            return { ...state, loading_station: false, station: null }

        case 'SET_FILTER':
            return { ...state, filter: action.payload.filter }
        case 'RESET_FILTER':
            return { ...state, filter: INITIAL_STATE.filter }

        case 'SET_FILTER_DATA_SUCCESS':
            var data2 = action.filter_data;

            if (action.filter_data.power === undefined) {
                data2['power'] = {
                    from: 0,
                    to: 350000
                }
            }

            return { ...state, filter: data2 }

        default:
            return state;
    }
};

export default reducer;